exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".chat-title{font-size:2em}.chat-body{margin:10px}.chat-body .details .key{font-size:90% !important;color:white;opacity:.5}.chat-body .details .alias{font-family:'DroidSansMonoDotted';background-color:#0000004F;padding:3px;border-radius:3px}.chat-body .details .invite-link{word-break:break-all;text-overflow:ellipsis}.chat-body .persons tbody{display:block;width:100%;max-height:300px;overflow-y:scroll}.chat-body .persons tbody tr,.chat-body .persons tbody td{display:block}.chat-body .persons .no-invite{color:#FFFFFFA0}\n", ""]);

// exports
